/* Native-app-style mobile bottom tab bar. Keeps the cart badge live via the
   theme's existing PUB_SUB_EVENTS.cartUpdate event (the same one
   sticky-cart-bar.js listens to) so it updates immediately on add-to-cart
   without a page reload. */
(function () {
  if (customElements.get("mobile-bottom-nav")) return;

  customElements.define(
    "mobile-bottom-nav",
    class MobileBottomNav extends HTMLElement {
      constructor() {
        super();
        this.badge = this.querySelector("[data-mobile-nav-cart-count]");
        this.cartButton = this.querySelector("[data-mobile-nav-cart-open]");

        if (this.cartButton) {
          this.cartButton.addEventListener("click", () => {
            const notification = document.querySelector("cart-notification");
            if (notification && typeof notification.open === "function") {
              // Same deferred-open pattern as sticky-cart-bar.js: open()
              // attaches a "click outside closes it" listener on
              // document.body synchronously, and this same click event is
              // still bubbling - opening on the next tick avoids it
              // immediately closing itself.
              setTimeout(() => notification.open(), 0);
            } else {
              window.location.href = "/cart";
            }
          });
        }

        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      refresh() {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then((response) => response.json())
          .then((cart) => this.render(cart))
          .catch(() => {});
      }

      render(cart) {
        if (!this.badge || !cart) return;
        this.badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          this.badge.removeAttribute("hidden");
        } else {
          this.badge.setAttribute("hidden", "");
        }
      }
    }
  );
})();
